<p-blockUI [blocked]="blocked">
    <div id="center">
      <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
</p-blockUI>

<div class="grid m-0 mt-4 text-primary">
	<div class="col-6">
		<div class="m-0 grid flex-column">
			<div class="col-12 py-0">
				<span>{{popUpComponent.popUpTitle}}</span>
			</div>
			<div class="col-12 py-0">
				<span>Plates count: {{plateScanValues.length}}</span>
                <span class="ml-2">Batch scanned: {{fetchBatchScanned()}}</span>
				<br/>
                <div class="flex align-items-center mt-2" *ngIf="popUpComponent.plateBatching || popUpComponent.plateUnbatching">
                    Plate <p-inputSwitch *ngIf="popUpComponent.plateBatching || popUpComponent.plateUnbatching" (onChange)="setUpComponentForUpdates()"  class="col-1" [ngModel]="batchView"></p-inputSwitch> Batch
                </div>
			</div>
			<div *ngIf="batchView" class="grid justify-content-start pb-0 m-0 col-6">
				<button pButton class="action-button h-1rem md:text-sm px-0 border-1 border-primary-600 text-primary col-12" type="button" label="Batch ID"></button>
			</div>
			<div *ngIf="batchView" class="grid justify-content-start pt-0 m-0" [ngClass]="getClassForScanDivs()">
				<input class="col" (input)="batchIDValid = false" pInputText name="batchId" id="popUpDialog-scan-batchId" [(ngModel)]="batchID" (keydown.enter)="validateBatchID()" [ngClass]="getClassForScanInputs()" />
			</div>
			<div class="grid justify-content-start pb-0 m-0" [ngClass]="getClassForScanDivs()">
				<button pButton *ngFor="let scan of popUpComponent.scans; let scanIndex=index;" class="action-button h-1rem md:text-sm px-0 border-1 border-primary-600 text-primary" type="button" label="{{scan.scanType=='MACHINE'?scan.scanType: scan.plateType}}" [ngClass]="getClassForScanInputs()"></button>
			</div>
			<div class="grid justify-content-start pt-0 m-0" [ngClass]="getClassForScanDivs()">
				<input *ngFor="let scan of popUpComponent.scans; let scanIndex=index;" class="col" pInputText name="plateId" id="popUpDialog-scan-{{scanIndex}}" [(ngModel)]="popUpScanInputValues[scanIndex]" [disabled]="(batchView && popUpComponent.plateUnbatching)|| disableScanInput" (keydown.enter)="validateScan(scanIndex, scan.scanType, popUpScanInputValues[scanIndex], scan.scanName, scan.plateType)" placeholder="{{scan.scanName}}" [ngClass]="getClassForScanInputs()" />
			</div>
			<div class="plate-scan-values">
				<div class="grid m-0" *ngFor="let scanValues of plateScanValues; let index = index;">
					<div class="grid justify-content-start py-0 m-0" [ngClass]="getClassForScanDivs()">
						<input *ngFor="let scan of scanValues; let scanIndex=index;" class="col p-1" pInputText [value]="scan" [ngClass]="getClassForScanInputs()" readonly/>
					</div>
					<div class="col-1 p-1">
						<button pButton icon="pi pi-times" class="p-button-danger p-1 text-sm" *ngIf="!(batchView && popUpComponent.plateUnbatching)" (click)="deleteScanValues(index)"></button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col-6">
		<div class="m-0 grid flex flex-column">
			<div class="col-12 w-auto flex my-1" *ngIf="popUpComponent.widgets.length == 0">
				<span>  </span>
			</div>
			<ng-container *ngFor="let widget of popUpComponent.widgets; let widgetIndex=index;">
				<div *ngIf="widget.type=='TEXT'" class="col-12">
					<span>{{widget.label}}</span>
				</div>

				<div *ngIf="widget.type=='CHECKBOX'" class="col-12">
					<p-checkbox [binary]="true" [label]="widget.label" [(ngModel)]="popUpWidgetCheckboxValues[widget.id]" [disabled]="disablePopupWidget(widgetIndex)"></p-checkbox>
				</div>

				<div *ngIf="widget.type=='EQUIPMENT'" class="col-12 p-inputgroup">
					<button pButton class="action-button w-4 h-1rem md:text-sm px-0 text-primary" type="button" [label]="widget.label"></button>
					<input pInputText [placeholder]="widget.label" class="w-6 py-0 px-1" [(ngModel)]="popUpWidgetInputValues[widget.id]" (focusout)="validateAndUpdateEquipmentValue(widget.id, widget.label, widgetIndex)" (keydown.enter)="validateAndUpdateEquipmentValue(widget.id, widget.label, widgetIndex)"  id="pop-up-input-{{widgetIndex}}" [disabled]="disablePopupWidget(widgetIndex)"/>
				</div>

				<div *ngIf="widget.type=='CHEMICAL_LOT'" class="col-12 pb-0 p-inputgroup">
					<button pButton class="action-button w-4 h-1rem md:text-sm px-0 text-primary" type="button" label="{{widget.label}}"></button>
					<input pInputText [placeholder]="widget.label" (keydown.enter)="addChemicalLot(widget.id)" class="w-6 py-0 px-1" [(ngModel)]="popUpWidgetInputValues[widget.id]" id="pop-up-input-{{widgetIndex}}" [disabled]="disablePopupWidget(widgetIndex)"/>
				</div>
				<ng-container *ngIf="widget.type=='CHEMICAL_LOT'">
					<div class="col-12 py-0 p-inputgroup" *ngFor="let widgetValue of plateWidgetValues.get(widget.id); let valueIndex = index;">
						<button pButton style="visibility: hidden" class="action-button w-4 h-1rem md:text-sm px-0 text-primary" type="button" label="{{widget.label}}"></button>
						<input pInputText [value]="widgetValue" class="w-6 py-0 px-1" readonly/>
						<button pButton icon="pi pi-times" class="p-button-danger p-1 text-sm" (click)="removeChemicalLot(widget.id, valueIndex)"></button>
					</div>
				</ng-container>
			</ng-container>
			<div class="col-12 w-auto flex my-1">
				<button pButton [label]="dialogHeader" class="min-w-min w-10rem h-2rem md:text-sm px-0 text-primary div-button-active" [ngClass]="dialogSubmitButtonClass" [disabled]="disableSubmitPopUpButton()" (click)="updateMultiplePlates()"></button>
			</div>
		</div>
	</div>
</div>

<p-confirmDialog styleClass="confirm-dialog" [style]="{width:'50vw'}"></p-confirmDialog>
